import { render, staticRenderFns } from "./CustomerSelect.vue?vue&type=template&id=342a44f4"
import script from "./CustomerSelect.vue?vue&type=script&lang=js"
export * from "./CustomerSelect.vue?vue&type=script&lang=js"
import style0 from "./CustomerSelect.vue?vue&type=style&index=0&id=342a44f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports